import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { Divider, TripSummaryCard } from '@landtrustinc/design-system';
import InquiryPricingDetails from './InquiryPricingDetails';
import itineraryDetailRows from './inquiryItineraryDetails';
import css from './InquiryTripSummary.module.css';

const InquiryTripSummary = ({
  summary,
  pricingView,
  showPricing,
  embedPricing,
  editLabel,
  onEdit,
  itinerary,
}) => {
  const showEmbeddedPricing = showPricing && embedPricing;
  const details = [...(summary.details || []), ...itineraryDetailRows(itinerary)];
  const card = (
    <TripSummaryCard
      className={showEmbeddedPricing ? css.summaryCardFlush : css.summaryCard}
      image={summary.image}
      title={summary.listingTitle}
      subtitle={summary.subtitle}
      details={details}
      iconStyle="tile"
      detailVariant="itinerary"
      onEdit={onEdit || undefined}
      editLabel={editLabel}
    />
  );

  return showEmbeddedPricing ? (
    <div className={css.summarySurface}>
      {card}
      <Divider />
      <InquiryPricingDetails pricingView={pricingView} />
    </div>
  ) : (
    card
  );
};

InquiryTripSummary.defaultProps = {
  pricingView: null,
  showPricing: false,
  embedPricing: false,
  editLabel: 'Edit',
  onEdit: null,
  itinerary: null,
};

InquiryTripSummary.propTypes = {
  summary: object.isRequired,
  pricingView: object,
  showPricing: bool,
  embedPricing: bool,
  editLabel: string,
  onEdit: func,
  itinerary: object,
};

export default InquiryTripSummary;
